import { Playground, Props } from "docz";
import { TeamBadge } from "@ssg-b2b/team-badge";
import * as React from 'react';
export default {
  Playground,
  Props,
  TeamBadge,
  React
};